import React, { Component } from 'react';

class Alert extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div style={{
        padding: ".5rem 1rem",
        background: this.props.background,
        borderRadius: "8px",
        fontWeight: 500,
        border: this.props.border,
        color: this.props.color,
        display: "flex",
        fontSize: "0.875rem",
        alignItems: "center"
      }}>
      { this.props.emoji && 
        <span
          style={{
            marginRight: "1rem"
          }}
        >{ this.props.emoji }</span>
      }
        <div>{ this.props.children }</div>
      </div>
    );
  }
}

export default Alert;



// WEBPACK FOOTER //
// ./src/components/alert/index.js